import { useCallback } from 'react';
import { useUserStore } from '@/store/userStore';
import {
  startIdentityVerification,
  userRequiresIdentityVerification,
} from '../utils/identityVerification';

export function useIdentityVerification() {
  const user = useUserStore((state) => state.user);

  const isBlocking = !!user && userRequiresIdentityVerification(user);

  const startVerification = useCallback(() => {
    startIdentityVerification();
  }, []);

  return {
    isBlocking,
    startVerification,
  };
}
